'use strict';

var publicKey = require('./public-key.js');

const NodeId = publicKey.PublicKey;

exports.NodeId = NodeId;
//# sourceMappingURL=node-id.js.map
